import React from "react";
import {
  Button,
  CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  TextField,
} from '@material-ui/core';
import "./Note.css";
import TopToolbar from "../global/subcomponents/topToolbar/TopToolbar";
import FeedbackBar from "../feedbackBar/FeedbackBar";
import withShipment from "../../withShipment";
import { userInfoSelector } from "../../redux/selectors/auth";
import { loadingSelector, notesSelector } from '../../redux/selectors/settings';
import { AddCircleOutline, Backspace } from '@material-ui/icons';
import { addNote, deleteNote, listNotes } from '../../redux/actions/settings';
import WriteGuard from '../global/ReadOnly/WriteGuard';

class Note extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      feedbackBarOpen: false,
      feedbackMessage: '',
      feedbackStatus: '',
      notes: [],
      newNoteText: '',
      showNoteInput: false,
      openConfirmDialog: false,
      deleteId: null,
    };
  }

  componentDidMount() {
    this.props.listNotes({locationId: this.props.userInfo.selectedLocationId});
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.notesList !== this.props.notesList) {
           this.setState({
              notes:this.props.notesList,
            })
      }
    }


  handleChange = (e) => {
    this.setState({ newNoteText: e.target.value });
  };

  handleSave = () => {
    const { newNoteText } = this.state;
    const newNote = {
      note: newNoteText,
      userId: this.props.userInfo.userId,
      locationId: this.props.userInfo.selectedLocationId,
      date: new Date().toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }),
    };

    this.setState(
      (prevState) => ({
        notes: [newNote, ...prevState.notes],
        newNoteText: '',
        showNoteInput: false,
      }),
      () => {
        this.props.addNote(newNote, callback);
      }
    );

    const callback = (error, response) => {
      if (error) {
        this.openFeedbackBar('error', error);
      } else {
        this.openFeedbackBar('success', response);
      }
    };
  };

  openFeedbackBar = (status, message) => {
    this.setState({
      feedbackStatus: status,
      feedbackMessage: message,
      feedbackBarOpen: true,
    });
  };

  closeFeedbackBar = () => {
    this.setState({
      feedbackBarOpen: false,
      feedbackStatus: '',
      feedbackMessage: '',
    });
  };

  openConfirmDialog = (deleteId) => {
    this.setState({ openConfirmDialog: true, deleteId: deleteId });
  };

  closeConfirmDialog = () => {
    this.setState({ openConfirmDialog: false, deleteId: null });
  };

  confirmDelete = () => {
    const notes = [...this.state.notes];
    notes.splice(this.state.deleteId, 1);
    this.props.deleteNote({noteId: this.state.deleteId, locationId: this.props.userInfo.selectedLocationId});
    this.setState({ notes, openConfirmDialog: false, deleteId: null });
  };

    userIsAnAdmin = () => {
        const { userInfo } = this.props;
        const roles = userInfo?.authority || [];
        return roles.includes("ROLE_ADMIN") || roles.includes("ROLE_MASTER_ADMIN");
    };

  render() {
    const { showNoteInput, newNoteText } = this.state;

    return (
      <React.Fragment>
        <TopToolbar pageName={'Notes'} />
        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
        />

        <Dialog
          open={this.state.openConfirmDialog}
          onClose={this.closeConfirmDialog}
          PaperProps={{
            style: {
              borderRadius: 16,
              padding: '20px',
              minWidth: '400px',
              boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
            },
          }}
        >
          <DialogTitle
            style={{
              fontWeight: 600,
              fontSize: '20px',
              color: '#333',
              paddingBottom: 0,
            }}
          >
            Delete Note?
          </DialogTitle>
          <DialogContent style={{ paddingTop: 10 }}>
            <DialogContentText style={{ fontSize: '16px', color: '#555' }}>
              Are you sure you want to delete this note? This action cannot be
              undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions
            style={{ justifyContent: 'flex-end', paddingTop: '8px' }}
          >
            <Button
              onClick={this.closeConfirmDialog}
              variant="outlined"
              style={{
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 500,
                color: '#555',
                borderColor: '#ccc',
                marginRight: '10px',
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={this.confirmDelete}
              variant="contained"
              style={{
                backgroundColor: '#e53935',
                color: '#fff',
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 500,
                boxShadow: 'none',
              }}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        {/* The composer's only entry point. Removed at a VIEW-ONLY
            location — the header bar goes with it so there's no empty
            strip left behind. */}
        <WriteGuard>
          <div className="note-header">
            <button
              className="add-note-btn"
              onClick={() => this.setState({ showNoteInput: !showNoteInput })}
            >
              <span className="plus-icon">
                <AddCircleOutline />
              </span>{' '}
              Add new note
            </button>
          </div>
        </WriteGuard>

        {showNoteInput && (
          <div style={{ margin: '24px' }}>
            <TextField
              label="Write your note"
              multiline
              rows={4}
              variant="outlined"
              fullWidth
              value={newNoteText}
              onChange={this.handleChange}
            />
            <WriteGuard>
              <Button
                style={{ marginTop: '10px' }}
                variant="contained"
                color="primary"
                onClick={this.handleSave}
                disabled={!newNoteText.trim()}
              >
                {this.props.loadingData ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  'Save'
                )}
              </Button>
            </WriteGuard>
          </div>
        )}

        <div className="note-list">
          {this.props.notesList?.map((note, index) => (
            <div key={index} className="note-card">
              {(this.props.userInfo.userId === note.userId || this.userIsAnAdmin) && (
                <WriteGuard>
                <button
                  className="delete-icon"
                  onClick={() => this.openConfirmDialog(note?.noteId)}
                >
                  <Backspace />
                </button>
                </WriteGuard>
              )}

              {/* Date with orange dot */}
              <div
                className="note-date"
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <span
                  className="dot"
                  style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    backgroundColor: '#f4c430',
                    marginRight: '6px',
                  }}
                ></span>
                {note.date}
              </div>

              <div className="note-title">{note.title}</div>

              <div className="note-body">{note.note}</div>

              {/* Display username at the end */}
              <div
                className="note-username"
                style={{ marginTop: '6px', fontStyle: 'italic', color: '#666' }}
              >
                — {note.userName} ({this.props.userInfo?.selectedLocationName})
              </div>
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  userInfo: userInfoSelector(state),
  loadingData: loadingSelector(state),
  notesList: notesSelector(state),
});

const actionCreators = {
  deleteNote,
  addNote,
  listNotes
};

export default withShipment({ actionCreators, mapStateToProps }, Note);